import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://happynookassociates.co.in';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

const PAGE_METADATA = {
  '/': {
    title: 'Engineering Consultant & Building Developer in Kolkata | Happy Nook Associates',
    description: 'Happy Nook Associates provides engineering consultancy, KMC sanction planning, structural design, and building development services in Kolkata.',
  },
  '/about': {
    title: 'About Happy Nook Associates | Engineering Consultants in Kolkata',
    description: 'Learn about Happy Nook Associates, a Kolkata engineering consultancy and building development partner with more than 25 years of project experience.',
  },
  '/what-we-do': {
    title: 'Engineering, Planning & Building Development Services | Happy Nook Associates',
    description: 'Explore engineering consultancy, structural design, KMC sanction planning, construction management, and building development services in Kolkata.',
  },
  '/portfolio': {
    title: 'Building Development Portfolio | Happy Nook Associates Kolkata',
    description: 'View selected building development, engineering, and construction projects completed by Happy Nook Associates in Kolkata and surrounding areas.',
  },
  '/contact': {
    title: 'Contact an Engineering Consultant in Kolkata | Happy Nook Associates',
    description: 'Contact Happy Nook Associates for engineering consultancy, building development, structural design, and KMC sanction planning in Kolkata.',
  },
  '/building-development': {
    title: 'Building Development Services in Kolkata | Happy Nook Associates',
    description: 'Partner with Happy Nook Associates for building development, construction planning, project coordination, and delivery from concept to completion.',
  },
  '/pg': {
    title: 'Naskar Villa Ladies PG in Kolkata | Safe Furnished Accommodation',
    description: 'Discover Naskar Villa Ladies PG in Dum Dum, Kolkata, offering secure furnished rooms, Wi-Fi, air conditioning, kitchens, and 24-hour water supply.',
  },
};

const SEO = () => {
  const { pathname } = useLocation();
  const metadata = PAGE_METADATA[pathname] || PAGE_METADATA['/'];
  const canonicalPath = PAGE_METADATA[pathname] ? pathname : '/';
  const canonicalUrl = `${SITE_URL}${canonicalPath === '/' ? '' : canonicalPath}`;

  return (
    <Helmet>
      <html lang="en" />
      <title>{metadata.title}</title>
      <meta name="description" content={metadata.description} />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:site_name" content="Happy Nook Associates" />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:title" content={metadata.title} />
      <meta property="og:description" content={metadata.description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={DEFAULT_IMAGE} />
      <meta property="og:image:alt" content="Happy Nook Associates" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metadata.title} />
      <meta name="twitter:description" content={metadata.description} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />
      <meta name="twitter:image:alt" content="Happy Nook Associates" />

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'Happy Nook Associates',
          url: SITE_URL,
          description: metadata.description,
          inLanguage: 'en-IN',
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
